// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, skeletonStyle } from "@awc/XDL/Utilities";
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import styled, { css } from "styled-components";

const SkeletonBaseElement = styled.div`
    ${skeletonStyle}
`;

export const SkeletonElement = styled(SkeletonBaseElement)<
    { height?: string; width?: string; hideBorder?: boolean } & InjectableCss
>`
    width: ${({ width }) => width || "100%"};
    min-height: ${({ height }) => height || "100%"};
    ${({ hideBorder }) => {
        if (hideBorder) {
            return css`
                border: none !important;
            `;
        }
    }}
    ${injectCss}
`;

interface OwnProps {
    width?: string;
    height?: string;
    isLoading?: boolean;
    hideBorder?: boolean;
}

type Props = OwnProps & InjectableCss;

const Skeleton = ({ width, height, isLoading = true, css, hideBorder = true }: Props) => {
    if (!isLoading) {
        return null;
    }

    return <SkeletonElement width={width} height={height} css={css} hideBorder={hideBorder} />;
};

export default Skeleton;
